import { useEffect, useRef } from "react";

interface HtmlRendererProps {
  htmlContent: string;
}

export const HtmlRenderer = ({ htmlContent }: HtmlRendererProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const removeEmbedAndTitleTag = (inputString: string) => {
    return (
      inputString &&
      inputString
        .replace(/<embed[^>]*>.*?<\/embed>|<embed[^>]*\/?>/gi, "")
        .replace(
          /<sub-panel-header[^>]*>.*?<\/sub-panel-header>|<sub-panel-header[^>]*\/?>/gi,
          ""
        )
    );
  };

  useEffect(() => {
    const container = containerRef.current;
    let tempScripts: any = [];
    if (container) {
      const scripts = container.querySelectorAll("script");
      scripts.forEach((script) => {
        const newScript = document.createElement("script");
        newScript.textContent = script.textContent;
        newScript.type = "text/javascript";
        newScript.defer = true;
        // newScript.src = script.innerText;
        newScript.async = true;
        document.head.appendChild(newScript);
        tempScripts.push(newScript);
      });
    }
    return () => {
      tempScripts.forEach((script: any) => document.head.removeChild(script));
    };
  }, [htmlContent]);

  return (
    <div ref={containerRef}>
      {/* <DangerouslySetHtmlContent html={htmlContent} /> */}
      <div
        dangerouslySetInnerHTML={{
          __html: removeEmbedAndTitleTag(htmlContent),
        }}
      />
    </div>
  );
};
